import {
  buildLegalConfig,
  buildLegalPlaceholders,
  type LegalRuntimeConfig,
} from '@noisy/legal';
import { environment } from '../../environments/environment';

export type RuntimeConfig = LegalRuntimeConfig;

export const legalConfig = buildLegalConfig({
  environment: environment as RuntimeConfig,
  defaultSiteName: 'Noisy Podcaster',
});

export const legalPlaceholders = buildLegalPlaceholders(legalConfig);
